import React from 'react';
import {Observable} from 'rxjs';
import {LoaderProps} from './loader';
import {ObservableLoader} from './observable-loader';

type Props = Omit<LoaderProps, 'show'> & { trackingService: {busy: Observable<any>} };

export class ServiceLoader extends React.PureComponent<Props> {
	public override render() {
		const {trackingService, ...baseProps} = this.props;
		return <ObservableLoader {...baseProps} observable={trackingService.busy}/>;
	}
}
